import type { ReactNode } from 'react';

import { LoadingIndicator } from '@adflow/frontend/ui-graphics';

import { styles } from './styles';

interface DataTableFullBodyProps {
	/** Children are required because this component only renders the table wrapper */
	children: ReactNode;

	showSpinner: boolean;
	showError: boolean;
	renderOnError?: ReactNode | null;
}

export function DataTableFullBody(props: DataTableFullBodyProps) {
	const { children, showSpinner, showError, renderOnError } = props;

	return (
		<div role="rowgroup" css={styles.body} data-testid="data-table-row-group">
			{showError && !!renderOnError ? (
				renderOnError
			) : showSpinner ? (
				<LoadingIndicator immediate />
			) : (
				children
			)}
		</div>
	);
}
